
import { mapGetters } from 'vuex';
import WCAddToListButton from '@/modules/lists/components/WCAddToListButton/WCAddToListButton.vue';
import WCImageGallery from '@/components/WCImageGallery/WCImageGallery.vue';
import WCTabNav from '@/components/WCTabNav/WCTabNav.vue';
import WCTab from '@/components/WCTab/WCTab.vue';
import WCNutritionFacts from '@/components/WCNutritionFacts/WCNutritionFacts.vue';
import WCCustomContent from '@/components/WCCustomContent/WCCustomContent.vue';
import WCProductDetails from '@/components/WCProductDetails/WCProductDetails.vue';
import WCProductPricing from '@/components/WCProductPricing/WCProductPricing.vue';
import CartControlsMixin from '@/modules/cart/mixins/CartControls/CartControls';
import WCBasicAddToCartButton from '@/modules/cart/components/WCBasicAddToCartButton/WCBasicAddToCartButton.vue';
import WCAlternateItems from '@/components/WCAlternateItems/WCAlternateItems.vue';
import OrderTypesMixin from '@/modules/orderTypes/mixins/OrderTypesMixin';
import HidePricingMixin from '@/mixins/HidePricingMixin';
import { defineComponent } from 'vue';
import CouponAvailabilityMixin from '@/modules/coupons/mixins/CouponAvailabilityMixin';
import WCProductCardGroup from '../../components/WCProductCardGroup/WCProductCardGroup.vue';
import WCCouponCard from '../../components/WCCouponCard/WCCouponCard.vue';
import ProductDetailMixin from './mixins/ProductDetailMixin';

export default defineComponent({
  components: {
    WCImageGallery,
    WCTabNav,
    WCTab,
    WCNutritionFacts,
    WCCustomContent,
    WCProductDetails,
    WCAddToListButton,
    WCProductPricing,
    WCAlternateItems,
    WCBasicAddToCartButton,
    WCProductCardGroup,
    WCCouponCard,
  },
  mixins: [
    ProductDetailMixin,
    CartControlsMixin,
    OrderTypesMixin,
    HidePricingMixin,
    CouponAvailabilityMixin,
  ],
  computed: {
    ...mapGetters({
      isGuest: 'user/isGuest',
      isCustomerModeScan: 'user/isCustomerModeScan',
    }),
  },
  data() {
    return {
      hasTabArrangement: true, // true|false to check if the tab has to be arranged.
    };
  },
});
